import {
  ADD_USER_MESSAGE,
  ADD_BOT_MESSAGE,
  SET_LOADING,
  CLEAR_CHAT,
  TOGGLE_CHATBOT,
  OPEN_CHATBOT,
  CLOSE_CHATBOT,
} from './chatbotActions'

const initialState = {
  messages: [],
  loading: false,
  isOpen: false,
}

export default function chatbotReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_USER_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      }
    case ADD_BOT_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
        loading: false,
      }
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case CLEAR_CHAT:
      return {
        ...initialState,
      }
    case TOGGLE_CHATBOT:
      return {
        ...state,
        isOpen: !state.isOpen,
      }
    case OPEN_CHATBOT:
      return {
        ...state,
        isOpen: true,
      }
    case CLOSE_CHATBOT:
      return {
        ...state,
        isOpen: false,
      }
    default:
      return state
  }
}
